import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { evaluarEstadoBadge, capitalizeFirstLetter } from '../../utils/funciones';
import { faEye, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { Celda, CeldaHeader } from './useCelda';
import { post } from '../../api/apis';
import { mensajeSimple, modalCargando } from '../../components/ui/sweetAlerts';
import Swal from 'sweetalert2';

// Función para extraer nombre y RUT del payload XML
const extraerDatosColaborador = (payload) => {
    try {
        if (!payload) return 'Sin información';
        
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(payload, "text/xml");
        
        // Extraer datos
        const nombres = xmlDoc.getElementsByTagName('nombres')[0]?.textContent || '';
        const apellidoPaterno = xmlDoc.getElementsByTagName('apellidoPaterno')[0]?.textContent || '';
        const apellidoMaterno = xmlDoc.getElementsByTagName('apellidoMaterno')[0]?.textContent || '';
        const rut = xmlDoc.getElementsByTagName('rut')[0]?.textContent || '';
        
        // Construir nombre completo
        const nombreCompleto = `${nombres} ${apellidoPaterno} ${apellidoMaterno}`.trim();
        
        if (!nombreCompleto && !rut) return 'Sin información';
        
        return `${nombreCompleto} - ${rut}`;
    } catch (error) {
        console.error('Error al parsear payload:', error);
        return 'Error al leer datos';
    }
};

export const getColumnas = (objStyleCol, verDetalleLog, recargarTabla) => ({
    temporis: [
        {
            name: <CeldaHeader label="ID" alineacion="center" />,
            selector: row => row.id,
            width: '80px',
            style: objStyleCol
        },
        {
            name: 'Administrador Solicitante',
            cell: row => <Celda label={capitalizeFirstLetter(row.user_creator_name)} ancho="500px" />,
            width: '300px',
            style: objStyleCol
        },
        {
            name: 'Colaborador',
            cell: row => <Celda label={extraerDatosColaborador(row.payload)} ancho="350px" />,
            width: '350px',
            style: objStyleCol
        },
        {
            name: <CeldaHeader label="Estado" alineacion="center" />,
            selector: row => evaluarEstadoBadge(row.status),
            wrap: true,
            style: objStyleCol,
            width: '100px',
        },
        {
            name: 'Mensaje emitido por Temporis',
            cell: row => <Celda label={row.resp_clean_temporis} ancho="600px" />,
            width: '600px',
            style: objStyleCol
        },
        {
            name: <CeldaHeader label="Creado" alineacion="center" />,
            selector: row => row.created_at,
            width: '170px',
            style: objStyleCol
        },
        {
            name: 'Acciones',
            wrap: true,
            width: '95px',
            button: true,
            style: objStyleCol,
            cell: (row) => {
                const reintentar = async (rowData) => {
                    try {
                        modalCargando('Procesando');
                        
                        // Verificar que exista el campo id_persona
                        const idPersona = rowData.id_persona || rowData.persona_id || rowData.idPersona;
                        
                        if (!idPersona) {
                            Swal.close();
                            mensajeSimple('error', 'No se encontró el ID de persona en el registro', 3000);
                            return;
                        }
                        
                        const resp = await post('crearColaboradorLog', null, { id_persona: idPersona, id_log : rowData.id, user_creator : rowData.user_creator  });
                        console.log('Respuesta del reintento:', resp);
                        Swal.close();

                        if (resp.data.status === 'error') {
                            mensajeSimple('error', resp.data.message || 'Error al reintentar la solicitud', 3000);
                            setTimeout(() => recargarTabla(), 2000);
                        } else if (resp.data.status === 'success') {
                            mensajeSimple('success', resp.data.message || 'Solicitud reintentada exitosamente', 3000);
                            // Recargar la tabla después de un reintento exitoso
                            if (recargarTabla) {
                                setTimeout(() => recargarTabla(), 2000);
                            }
                        } else {
                            mensajeSimple('info', resp.data.message || 'Solicitud procesada', 3000);
                        }
                    } catch (error) {
                        console.error('Error al reintentar:', error);
                        Swal.close();
                        mensajeSimple('error', 'Error al procesar la solicitud', 3000);
                        setTimeout(() => recargarTabla(), 2000);
                    }
                };

                return (
                    <div className='d-flex w-100 justify-content-center'>
                        <button
                            className="btn btnAccion btn-primary btn-sm"
                            data-bs-toggle="tooltip" title="Ver detalle"
                            onClick={() => {
                                // console.log(row);
                                verDetalleLog(row)
                            }}
                        >
                            <FontAwesomeIcon icon={faEye} title='Ver detalle' />
                        </button>

                            <button style={{ visibility: Number(row.status) === 2 ? 'visible' : 'hidden' }}
                                className="btn btnAccion btn-primary btn-sm"
                                data-bs-toggle="tooltip" title="Reintentar"
                                onClick={() => {
                                    reintentar(row)
                                }}
                            >
                                <FontAwesomeIcon icon={faRedoAlt} title='Reintentar' />
                            </button>

                    </div>
                )
            }
        }
    ]
})


